import { Fragment } from "react";
import { Button, ButtonGroup, Col, Row } from "react-bootstrap";

const PlaylistsProgramsButton = (
  isLoading,
  error,
  daysPrograms,
  handleProgramClick,
  selectedProgram,
  convertMinutesToTime,
  formatRuntime
) => {
  return (
    <Col xs={6}>
      <Row>
        <ButtonGroup
          size="sm"
          vertical
        >
          {isLoading ? (
            <div>Loading...</div>
          ) : error ? (
            <div>Error fetching playlist programs. Please try again later.</div>
          ) : (
            daysPrograms &&
            daysPrograms.map((program) => (
              <Fragment key={program.programs._id}>
                {program.programs.gap > 0 && (
                  <Row className="badge text-bg-warning m-auto my-2  ">
                    <Col>ERROR - Gap {program.programs.gap} mins</Col>
                  </Row>
                )}
                {program.programs.gap < 0 && (
                  <Row className="badge text-bg-info m-auto my-2">
                    <Col>ERROR - Overlap {program.programs.gap} mins</Col>
                  </Row>
                )}
                <Button
                  id={program.programs._id}
                  onClick={() => handleProgramClick(program.programs._id)}
                  variant={
                    program.programs._id === selectedProgram
                      ? "primary"
                      : "light"
                  }
                >
                  <Row className="py-1 ">
                    <Col
                      xs={1}
                      className="text-sm-start"
                    >
                      {convertMinutesToTime(
                        program.programs.startTime.startTime
                      )}
                    </Col>
                    <Col
                      className={`text-sm-start ${
                        !program.programs.templateProgramID ? "text-danger" : ""
                      } ${
                        program.programs.startTime?.isDirty ||
                        program.programs.synopsis?.isDirty ||
                        program.programs.isLive?.isDirty ||
                        program.programs.isAvailable?.isDirty ||
                        program.programs.startTime?.isDirty ||
                        program.programs.slotRuntime?.isDirty ||
                        program.programs.mediaRuntime?.isDirty ||
                        program.programs.isLocked?.isDirty ||
                        program.programs.addBreak?.isDirty ||
                        program.programs.preRoll?.file?.ident?.isDirty ||
                        program.programs.preRoll?.live?.ident?.isDirty ||
                        program.programs.preRoll?.live?.introIdent?.isDirty
                          ? "text-success"
                          : ""
                      }`}
                      xs={6}
                    >
                      {program.programs.name?.isDirty ||
                      program.programs.synopsis?.isDirty ||
                      program.programs.isLive?.isDirty ||
                      program.programs.isAvailable?.isDirty ||
                      program.programs.startTime?.isDirty ||
                      program.programs.slotRuntime?.isDirty ||
                      program.programs.mediaRuntime?.isDirty ||
                      program.programs.isLocked?.isDirty ||
                      program.programs.addBreak?.isDirty ||
                      program.programs.preRoll?.file?.ident?.isDirty ||
                      program.programs.preRoll?.live?.ident?.isDirty ||
                      program.programs.preRoll?.live?.introIdent?.isDirty
                        ? "* "
                        : ""}
                      {!program.programs.templateProgramID ? "+ " : ""}
                      {program.programs.name?.name}
                    </Col>

                    <Col
                      className="text-sm-start"
                      xs={2}
                    >
                      {formatRuntime(program.programs.slotRuntime.slotRuntime)}
                    </Col>
                    <Col
                      className="text-sm-end"
                      xs={3}
                    >
                      {program?.programs?.isLive?.isLive ? (
                        <span className="badge bg-danger p-2 mx-2  "> </span>
                      ) : (
                        <span className="badge p-2 mx-2  "> </span>
                      )}
                      {program?.programs?.isAvailable?.isAvailable ? (
                        <span className="badge bg-success p-2 mx-2  "> </span>
                      ) : (
                        <span className="badge p-2 mx-2  "> </span>
                      )}
                      {program?.programs?.isLocked?.isLocked ? (
                        <span className="badge bg-warning p-2 mx-2  "> </span>
                      ) : (
                        <span className="badge p-2 mx-2  "> </span>
                      )}
                    </Col>
                  </Row>
                </Button>
              </Fragment>
            ))
          )}
        </ButtonGroup>
      </Row>
    </Col>
  );
};
export default PlaylistsProgramsButton;
